import { constantRoutes } from '@/router'

export const getRoutes = pages => {
  const newRoutes = []
  for (let i = 0; i < constantRoutes.length; i++) {
    const newChildren = []
    if (constantRoutes[i].children) {
      const children = constantRoutes[i].children
      for (let j = 0; j < children.length; j++) {
        if (children[j].meta) {
          if (pages.indexOf(children[j].meta.page) !== -1) {
            if (children[j].meta.hidden !== true) {
              newChildren.push(children[j])
            }
          }
        }

        if (newChildren.length > 0 && children[j].divider) {
          newChildren.push(children[j])
        }
      }
    }

    if (constantRoutes[i].divider) {
      newChildren.push(constantRoutes[i])
    }

    if (newChildren.length !== 0) {
      const constantRoutesChildren = constantRoutes[i]
      constantRoutesChildren.children = newChildren

      newRoutes.push(constantRoutesChildren)
    }
  }

  // cut off divider
  const filterNewRoutes = []
  let temp = {}
  for (let i = 0; i < newRoutes.length; i++) {
    const item = newRoutes[i]

    if (item.divider) {
      if (!temp.divider && i > 0 && i < newRoutes.length - 1)
        filterNewRoutes.push(item)
    } else {
      if (item.children && item.children.length > 1) {
        const filterChild = []
        let tempChildren = {}
        for (let j = 0; j < item.children.length; j++) {
          const child = item.children[j]
          if (child.divider) {
            if (!tempChildren.divider && j > 0 && j < item.children.length - 1)
              filterChild.push(child)
          } else {
            filterChild.push(child)
          }

          tempChildren = child
        }

        item.children = filterChild
      }

      filterNewRoutes.push(item)
    }

    temp = item
  }

  if (filterNewRoutes.length > 0) {
    if (!filterNewRoutes[filterNewRoutes.length - 1].path)
      filterNewRoutes.splice(filterNewRoutes.length - 1, 1)
  }

  return filterNewRoutes
}
